import React from "react";

let NoPage = () =>{
    return(
        <p>
            Nopage
        </p>
    )
}

export  default NoPage